const prefix = 'is-';

const getStateClassName = (value: string): string => (value ? `${prefix}${value}` : '');

export default getStateClassName;
